import React, { Component, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { Logger } from "./infrastructure/Logger";
import { Configuration } from "./infrastructure/Configuration";
import { PushCommandClient } from "./infrastructure/NotificationSubscribers";
import { CapabilityName } from "./infrastructure/Constants";
import { CapabilityRegistry, Capabilities } from "./infrastructure/Capabilities";
import { BackSplashComponent } from "./capabilities/BackSplashComponent";
import { LoaderComponent } from "./capabilities/LoaderComponent";
import { ModalComponent } from "./capabilities/ModalComponent";
import { CapabilitiesContext, UserContext } from "./infrastructure/Contexts";
import { SettingsContext } from "./infrastructure/SettingsContext";
import "./wiki.css";
import "./global.css";
import { HomeView } from "./migrated/views/home/HomeView";
import NiceModal from "@ebay/nice-modal-react";
import { ArticleView } from "./migrated/views/articles/ArticleView";
import { ArticlesByTagView } from "./migrated/views/search/ArticlesByTagView";
import { ArticleEditView } from "./migrated/views/articles/ArticleEditView";
import { LatestArticles } from "./migrated/views/home/LatestArticles";
import useNotifications from "./core/Notifications";
import { Loader, LoaderContext, LoaderProvider } from "./core/Loader";
import { ContentNotFoundReportView } from "./migrated/views/reports/ContentNotFoundReportView";

export default function App() {
    const displayName = App.name;
    const capabilities = new CapabilityRegistry();
    const notifications = useNotifications();

    const [config, setConfig] = useState(null);

    useEffect(() => {
        console.log("Application initializing");
        async function init() {
            let configuration = new Configuration();

            try {
                var config = await configuration.getConfigAsync();

                if (config) {
                    var notificationClient = new PushCommandClient(
                        config.settings["Notifications:PushWebSocketUri"],
                        config.settings["Security:ClientId"],
                        config.user.sid
                    );
                    var notificationRegistry = notificationClient.getSubscriberRegistry();

                    notificationRegistry.registerHandler(onCommandReceived);

                    var configData = {
                        user: config.user,
                        settings: config.settings,
                        capabilities: capabilities,
                        notificationSubscribers: notificationRegistry,
                    };

                    Logger.writeDebug("configData", configData);

                    setConfig(configData);
                    console.log("Finished");
                }
            } catch (ex) {
                console.log("Application initialization has failed. Redirecting to login page.", ex);
                window.location.replace("account/login");
            }
        }
        init();
    }, []);

    const onCommandReceived = (command) => {
        if (command && command.Properties) {
            if (command.Properties.content) {
                notifications.info({
                    message: command.Properties.content,
                });
            }
        }
    };

    return (
        <div className="order">
            <BackSplashComponent capabilityRegistry={capabilities} id={CapabilityName.BackSplash} />
            <LoaderComponent capabilityRegistry={capabilities} id={CapabilityName.Loader} />
            <ModalComponent capabilityRegistry={capabilities} id={CapabilityName.Modal} />

            {config && (
                <SettingsContext.Provider value={{ settings: config.settings }}>
                    <UserContext.Provider value={config.user}>
                        <CapabilitiesContext.Provider value={config.capabilities}>
                            <NiceModal.Provider>
                                <LoaderProvider>
                                    <Layout>
                                    <Loader />
                                        <Routes>
                                            <Route index={true} key={0} element={<HomeView />} />
                                            <Route path="/articles/:articleId" element={<ArticleView type="id" />} />
                                            <Route path="/articles/new" element={<ArticleEditView />} />
                                            <Route path="/articles/:articleId/edit" element={<ArticleEditView />} />
                                            <Route path="/article/:articleName" element={<ArticleView type="html" />} />
                                            <Route path="/tags/:tagId/articles" element={<ArticlesByTagView />} />
                                            <Route path="/search" element={<LatestArticles />} />
                                            <Route path="/reports/contentNotFound" element={<ContentNotFoundReportView />} />
                                        </Routes>
                                    </Layout>
                                </LoaderProvider>
                            </NiceModal.Provider>
                        </CapabilitiesContext.Provider>
                    </UserContext.Provider>
                </SettingsContext.Provider>
            )}
        </div>
    );
}
